export const componentReady = (state) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('media-gallery.ready', state);
  }
};

export const mediaClick = (payload) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('media-gallery.click', payload);
  }
};

export const thumbnailClick = (payload) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('media-gallery.thumbnail_click', payload);
  }
};

export const userImagesClick = (payload) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('media-gallery.user-images_click', payload);
  }
};
